module.exports = __webpack_public_path__ + "img/assar.8075d3a6.svg";